import { getInitialState, getPath } from "../../utils";

const initialState = {
  telecallerProfiles: [],
  telecallerClusters: [],
  prevPage: -1,
  nextPage: -1,
  activeTelecaller: {},
  activeFilters: {},
  currentPage: 1,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_TELECALLER_PROFILES":
      return setTelecallerProfiles(state, action);
    case "SET_ACTIVE_TELECALLER":
      return setActiveTelecaller(state, action);
    case "SET_ACTIVE_FILTERS_TELECALLER":
      return setActiveFiltersTelecaller(state, action);
    case "SET_CURRENT_PAGE_TELECALLERS":
      return setCurrentPageTelecallers(state, action);
    case "SET_CLUSTERS_TELECALLER":
      return setClustersTelecaller(state, action);
    case "RESET_STATE_TELECALLER":
      return resetStateTelecaller(state, action);
    default:
      return state;
  }
}

const setClustersTelecaller = (state, action) => {
  return {
    ...state,
    telecallerClusters: getPath(action.payload, "clusters", []),
  };
};

const setCurrentPageTelecallers = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setTelecallerProfiles = (state, action) => {
  return {
    ...state,
    telecallerProfiles: getPath(action.payload, "telecallers", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const resetStateTelecaller = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveTelecaller = (state, action) => {
  return {
    ...state,
    activeTelecaller: getPath(action.payload, "telecaller", {}),
  };
};

const setActiveFiltersTelecaller = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
